<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editSp" ref="editSpRef" label-width="170px">
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">上级机构(必选)</span>
            </label>
            <Rsljigou :propsjigouid="editSp.parentid" :propsjigouname="editSp.parentname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">机构名称(必填)</span>
            </label>
            <el-input v-model="editSp.jigouname"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">权限角色(必选)</span>
            </label>
            <el-select v-model="editSp.roleid" placeholder="请选择" style="width: 100%">
              <el-option label="运营商店员权限" value="3"></el-option>
              <el-option label="运营商店员权限+设备归属" value="36"></el-option>
              <el-option label="运营商店员权限+微盘" value="34"></el-option>
              <el-option label="运营商采购权限" value="5"></el-option>
              <el-option label="运营商老板权限" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">是否开通提现(必选)</span>
            </label>
            <el-select v-model="editSp.tixian" placeholder="请选择" style="width: 100%">
              <el-option label="不开通提现账号" value="0"></el-option>
              <el-option label="开通提现账号" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提现账号姓名" class="addAdminForm" v-if="editSp.tixian == 1">
            <el-input v-model="editSp.username"></el-input>
          </el-form-item>
          <el-form-item label="提现账号手机" class="addAdminForm" v-if="editSp.tixian == 1">
            <el-input v-model="editSp.phone"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  data () {
    return {
      editSp: {
        id:'',
        parentid: '',
        parentname: '',
        jigouname: '',
        roleid: '3',
        phone: '',
        username: '',
        tixian: '0'
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editSp.id = row.Id
      this.editSp.parentid = row.Parentid.toString()
      this.editSp.parentname = row.Parentname
      this.editSp.jigouname = row.Jigouname
      this.editSp.roleid = row.Roleid.toString()
      this.editSp.username = row.Username
      this.editSp.phone = row.Phone
      if(this.editSp.phone.length > 0){
        this.editSp.tixian = '1'
      } else {
        this.editSp.tixian = '0'
      }
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditShenPiJiGou()
    },
    changeRsljigou (vid, vname) {
      this.editSp.parentid = vid
      this.editSp.parentname = vname
    },
    apiEditShenPiJiGou: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.editSp.id,
        parentid: that.editSp.parentid,
        jigouname: that.editSp.jigouname,
        roleid: that.editSp.roleid,
        username: that.editSp.username,
        phone: that.editSp.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditShenPiJiGou, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
